import { useEffect, useState } from "react";
import { Container, Row, Col, Modal, FormSelect, FormControl, Button } from "react-bootstrap";
import "./../lobby.css";
import nakamaUtilInstance, { user, client, session, socketConnected, socket, sessionTimeoutCheck } from './../../../utils/nakama';
import dailybonusimage from "./../../../assets/images/bonez_mystery_bag.png";
import metamaskIcon from './../../../assets/images/metamask_icon.svg'

export default function WelcomeModal(props){

const [walletId, setWalletId] = useState(props.walletId);

const isVolatileAccount = (() => {
    try {
        if (user && user.metadata) {
            const metadata = JSON.parse(user.metadata);
            return metadata.account_type === 'volatile';
        }
    } catch (e) {
        // metadata parse failed
    }
    return false;
})();

useEffect(() => {
    setWalletId(props.walletId);
}, [props.walletId]);

const handleDismiss = async () => {
    props.setShowModal(false);
    try {
        const res = await client.rpc(session, "updateWelcome", {});
        if(res.payload.code === "ok"){
            console.log("Welcome modal dismissed");
        }
    } catch (error) {
        console.log("Error calling updateWelcome rpc:", error);
    }
}

const redirectToBridge = () => {
    console.log("redirecting to bridge");
    window.location.href = "https://zoombies.world/auth/bridge";
}

const redirectToSecureAccount = () => {
    window.location.href = "https://zoombies.world/auth/accounts";
}

    return(
        <Modal size="lg" show={props.showModal} onHide={() => {props.setShowModal(false)}} centered>
            <div className="whole-container container-body-text" style={{textAlign: "center"}}>
                <p className="mt-2 mb-5" style={{fontSize: "4rem", fontWeight: "bold"}}>Welcome to the &#129460; Bonez Arena</p>
                <p style={{fontSize: "2.5rem", color: "#FFFF00"}}>In partnership with N3MUS, we are excited to bring you the <img src="https://www.n3mus.com/logo.svg" alt="N3MUS" className="n3mus-logo"/> N3MUS leaderboard tournament with a <span style={{color: "#00FF00"}}>$500</span> value prize pool!</p>
                <p style={{fontSize: "2.5rem", color: "#FFFFFF"}}>
                    <span style={{color: "#FFFF00"}}>
                        1.
                    </span>
                    {walletId ?
                        <span style={{color: "#00FF00"}}>
                            The connected WEB3 wallet is eligible for the N3MUS leaderboard tournament
                        </span>
                    :
                        <span style={{color: "#FFFFFF"}}>
                            Connect WEB3 wallet to be eligible for the N3MUS leaderboard tournament
                        </span>
                    }
                <br/ ><span style={{color: "#FFFF00"}}>2.</span>Remember only <img
                                        className="icon-chipz"
                                        title="Zoombies Chipz"
                                        src="https://zoombies.world/images/bonez/bonez_chipz_credit.webp"
                                        alt="Chipz icon"
                                    /> Chipz matches count towards the N3MUS leaderboard tournament
                <br/ ><span style={{color: "#FFFF00"}}>3.</span>&#127942; Beat your opponent to a score of 21 to win the pot & climb the leaderboards!
                <br/ ><span style={{color: "#FFFF00"}}>4.</span>Check back daily for news updates and to collect your&nbsp;
                                        <img
                                            className="image-shop"
                                            style={{width: "26px", height: "30px"}}
                                            title="Daily Bonus"
                                            src={dailybonusimage}
                                            alt="Daily Bonus icon"
                                        /> bonus</p>
                <Row className="mt-5 mb-3">
                    <Col>
                    {isVolatileAccount ?
                        <Button size="lg" variant="warning" onClick={redirectToSecureAccount} style={{fontSize: "26px"}}>Secure Account</Button>
                    : !walletId ?
                        <Button size="lg" variant="success" onClick={redirectToBridge} style={{fontSize: "26px"}}>Connect WEB3</Button>
                    :
                    <><span>
                        <img src={metamaskIcon} alt="Metamask Icon" style={{ width: "40px", height: "40px" }} />Web3 Connected<br/>
                    </span><span style={{ color: '#FFFFFF', fontSize: '1.5rem' }}>
                        {walletId ? `${walletId.slice(0, 5)}...${walletId.slice(-5)}` : ''}
                    </span></>
                    }
                    </Col>
                    <Col>
                        <Button size="lg" variant="secondary"  style={{fontSize: "26px"}} onClick={() => props.setShowModal(false)}>Got it</Button>
                    </Col>
                    <Col>
                        <Button size="lg" variant="danger" style={{fontSize: "26px"}} onClick={handleDismiss}>Dismiss</Button>
                    </Col>
                </Row>
            </div>
        </Modal>
    )
}